import excludeProductsSlice from "./ExcludeProductsSlice";

const rollingProductSlice = {
    excludeProductsSlice : excludeProductsSlice,
};

export default rollingProductSlice;